export default __webpack_public_path__ + "static/media/chainleak.567952c2.jpeg";